import React from "react";
import { Card, List } from "antd";
import { RiBaseStationFill } from "react-icons/ri";
import StationFilters from "./StationFilters";
import StationListItem from "./StationListItem";
import BatchActionBar from "./BatchActionBar";

const StationList = ({
  stations,
  filteredStations,
  placedStations,
  stationsLoading,
  nameFilter,
  onNameFilterChange,
  placementFilter,
  onPlacementFilterChange,
  categoryFilter,
  onCategoryFilterChange,
  getUniqueCategories,
  isStationPlaced,
  onStationClick,
  onRemoveStation,
  onUpdateRadius,
  onUpdateAllowedPersonnel,
  personnel,
  selectedStationId,
  setSelectedStationId,
  batchMode,
  onBatchModeToggle,
  selectedStationsOrder,
  selectedUnplacedCount,
  selectedPlacedCount,
  onSelectionChange,
  onSelectAll,
  onDeselectAll,
  onBatchPlace,
  onOpenReorder,
  onBatchRemove,
}) => {
  return (
    <Card
      size="small"
      title={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <RiBaseStationFill
              style={{
                fontSize: 18,
                color: "#595959",
              }}
            />
            <span>基站列表</span>
          </div>
          <span
            style={{
              fontSize: 12,
              color: "#8c8c8c",
              fontWeight: "normal",
            }}
          >
            {placedStations.length}/{stations.length} 已放置
          </span>
        </div>
      }
      bordered
      bodyStyle={{
        padding: 12,
        height: 460,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <StationFilters
        nameFilter={nameFilter}
        onNameFilterChange={onNameFilterChange}
        placementFilter={placementFilter}
        onPlacementFilterChange={onPlacementFilterChange}
        categoryFilter={categoryFilter}
        onCategoryFilterChange={onCategoryFilterChange}
        getUniqueCategories={getUniqueCategories}
        batchMode={batchMode}
        onBatchModeToggle={onBatchModeToggle}
      />
      {batchMode && (
        <BatchActionBar
          selectedUnplacedCount={selectedUnplacedCount}
          selectedPlacedCount={selectedPlacedCount}
          onSelectAll={onSelectAll}
          onDeselectAll={onDeselectAll}
          onBatchPlace={onBatchPlace}
          onOpenReorder={onOpenReorder}
          onBatchRemove={onBatchRemove}
        />
      )}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          minHeight: 0,
          padding: batchMode ? "10px 10px 0 10px" : 0,
          margin: batchMode ? "-10px -10px 0 -10px" : 0,
        }}
      >
        <List
          size="small"
          loading={stationsLoading}
          dataSource={filteredStations}
          locale={{ emptyText: "沒有符合條件的基站" }}
          renderItem={(item) => (
            <StationListItem
              station={item}
              isPlaced={isStationPlaced(item)}
              onStationClick={onStationClick}
              onRemoveStation={onRemoveStation}
              onUpdateRadius={onUpdateRadius}
              onUpdateAllowedPersonnel={onUpdateAllowedPersonnel}
              personnel={personnel}
              selectedStationId={selectedStationId}
              setSelectedStationId={setSelectedStationId}
              batchMode={batchMode}
              isSelected={selectedStationsOrder.has(item.id)}
              selectionOrder={selectedStationsOrder.get(item.id)}
              onSelectionChange={onSelectionChange}
            />
          )}
        />
      </div>
    </Card>
  );
};

export default StationList;
